export var reduxKey = '@@modals';
export var actionPrefix = '@@MODALS';
//# sourceMappingURL=constants.js.map